<template>
  <v-navigation-drawer
      v-model="drawerOpen"
      :color="color"
      app
      absolute
      :temporary="overlay"
      :right="!$vuetify.rtl"
      :left="$vuetify.rtl"
      @input="toggle"
      height="calc(100vh - 90px)"
      width="50vw"
      class="mx-auto transition-ease-in-out"
      style="min-width: 350px;"
      :style="{ 'box-shadow': true ? '0 -5px 7px 1px rgba(0,0,0,0.5)' : '' }"
  >
    <div style="height:90px"></div>


    <v-btn @click="close" text><v-icon>mdi-close</v-icon> {{$t('general.close')}}</v-btn>

    <v-card :color="color" flat style="height: calc(100% - 90px)">
      <v-card-text class="fill-height" style="overflow-y: auto">
        <slot></slot>
      </v-card-text>
    </v-card>

  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "ContentDrawer",
    props: {
      value:{
        type: Boolean,
        default: false,
      },
      overlay:{
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: null
      }
    },
    data(){
      return {
        drawerOpen: false,
      }
    },
    watch:{
      'value'(val){
        this.drawerOpen = val;
      }
    },
    methods: {
      close(){
        this.$emit('close');
        this.drawerOpen = false;
      },
      toggle(){
        this.$emit('input',this.drawerOpen);
      }
    }
  }
</script>

<style scoped>

</style>
